import constantFactory from "@gaoding/constant-factory";

export const {
  COOKIE_KEY,
  COOKIE_KEY_LIST,
  COOKIE_KEY_MAP,
  COOKIE_KEY_ITEM_MAP,
} = constantFactory("COOKIE_KEY", [
  {
    key: "IMAGE_URL_CONFIG_DOMAIN",
    label: "图片地址域名",
    value: "IMAGE_URL_CONFIG_DOMAIN",
  },
  {
    key: "IMAGE_URL_CONFIG_BUCKET_REG",
    label: "图片地址Bucket规则",
    value: "IMAGE_URL_CONFIG_BUCKET_REG",
  },
  {
    key: "IMAGE_URL_CONFIG",
    label: "图片地址配置",
    value: "IMAGE_URL_CONFIG",
  },
]);
